import { IReviewResponse } from '@customTypes/modelResponses'
import CardWrapper from '@libs/cards/CardWrapper'
import ReviewCard, { ReviewCardSliderWrapper } from '@libs/cards/ReviewCard'
import GridGallery from '@libs/slider/GridGallery'
import { useMemo } from 'react'

interface IDetailsPageReviewsSectionProps {
  title?: string
  reviewsData?: IReviewResponse[]
}

const DetailsPageReviewsSection = ({
  title,
  reviewsData,
}: IDetailsPageReviewsSectionProps): JSX.Element => {
  const cardComponents = useMemo(() => {
    return reviewsData?.map((review) => {
      return (
        <CardWrapper key={review?.id} widthPercentage={100}>
          {/*
          https://cms.devcrvtestingmm.com/admin/content-manager/collectionType/api::review.review/5
          GET: reviewText, country, date, reviewerName, Headshot
          */}
          <ReviewCard
            review={review.ReviewText}
            country={review?.Country}
            date={review?.Date}
            reviewer={review?.ReviewerName}
            headshot={review?.Headshot}
          />
        </CardWrapper>
      )
    })
  }, [reviewsData])

  return (
    <div className='mx-5 mt-[2.5rem] desktop:mx-0 desktop:mb-[4.5rem] desktop:max-w-[150rem]'>
      <h2 className='mb-[2.563rem] max-w-[350px] text-h2 font-semibold desktop:mb-[4.125rem] desktop:max-w-none'>
        {title} Reviews
      </h2>
      <div className='-ml-[0.6rem]'>
        <ReviewCardSliderWrapper leftOffset='10px'>
          <GridGallery
            components={cardComponents}
            responsiveGridConfig={{
              desktop: {
                itemsPerRow: 2,
                itemHeight: 600,
              },
              tablet: {
                itemsPerRow: 1,
                itemHeight: 600,
              },
              mobile: {
                itemsPerRow: 1,
                itemHeight: 430,
              },
            }}
          />
        </ReviewCardSliderWrapper>
      </div>
    </div>
  )
}

export default DetailsPageReviewsSection
